var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6768"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6765"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 241",
    d: "M11.5 0A11.5 11.5 0 1023 11.5 11.493 11.493 0 0011.5 0zm0 21.2a9.7 9.7 0 119.7-9.7 9.7 9.7 0 01-9.7 9.7z",
    fill: "#fc035d"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6766"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 242",
    d: "M11.502 5.789a.9.9 0 00-.9.9v5.786a.9.9 0 101.8 0V6.689a.9.9 0 00-.9-.9z",
    fill: "#fc035d"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6767"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 71"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 25",
    cx: 1.213,
    cy: 1.213,
    fill: "#fc035d",
    r: 1.213,
    transform: "translate(10.287 14.473)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmWarning);
export default __webpack_public_path__ + "static/media/am-warning.0eab6a3ba10bdf9dcfccdf8a3a559957.svg";
export { ForwardRef as ReactComponent };